<header id="header" class="fixed-top">
  <div class="container d-flex align-items-center">

    <h1 class="logo mr-auto"><a href="javascript:void(0)">min</a></h1>
    <!-- Uncomment below if you prefer to use an image logo -->
    <!-- <a href="index.html" class="logo mr-auto"><img src="assets/img/logo.png" alt="" class="img-fluid"></a> -->

    <nav class="nav-menu d-none d-lg-block">
      <ul>
        <li class="active"><a href="javascript:void(0)" title="Home">Home</a></li>
        <li class="drop-down"><a href="javascript:void(0)" title="products">Products </a>
          <ul>
            <li><a href="javascript:void(0)" title="min">min MFA</a></li>
            <li><a href="javascript:void(0)" title="min Block">min Block</a></li>
            <li><a href="javascript:void(0)" title="min SSO">min SSO</a></li>
            <li><a href="javascript:void(0)" title="min Consent">min Consent</a></li>
          </ul>
        </li>
        <li class="drop-down"><a href="javascript:void(0)" title="Solutions">Solutions </a>
          <ul>
            <li><a href="javascript:void(0)" title="min">min MFA</a></li>
            <li><a href="javascript:void(0)" title="min Block">min Block</a></li>
            <li><a href="javascript:void(0)" title="min SSO">min SSO</a></li>
            <li><a href="javascript:void(0)" title="min Consent">min Consent</a></li>
          </ul>
        </li>
        <li class="drop-down"><a href="javascript:void(0)" title="Services">Services </a>
          <ul>
            <li><a href="javascript:void(0)" title="min">min MFA</a></li>
            <li><a href="javascript:void(0)" title="min Block">min Block</a></li>
            <li><a href="javascript:void(0)" title="min SSO">min SSO</a></li>
            <li><a href="javascript:void(0)" title="min Consent">min Consent</a></li>
          </ul>
        </li>
        <li><a href="javascript:void(0)" title="About">About</a></li>
        <li><a href="" [routerLink]="['/contactus']" title="Contact us" routerLinkActive="router-link-active" >Contact Us</a></li>

      </ul>
    </nav><!-- .nav-menu -->

    <button [routerLink]="['/login']" routerLinkActive="router-link-active" class="btn btn-outline btn-sm ml-20 px-20">Login</button>

  </div>
</header><!-- End Header -->

<!-- ======= Hero Section ======= -->
<!-- <section id="hero" class="d-flex justify-content-center align-items-center">
  <div class="container position-relative">
    <h1>A big business starts small.</h1>
    <h2>A platform that helps Applications Succeed!</h2>
    <a href="" class="btn-get-started">Get Started</a>
  </div>
</section> -->
<!-- End Hero -->

<main id="main">

  <!-- ======= About Section ======= -->
  <section id="about" class="about mt-5 py-90">
    <div class="container">

        <!-- <div class="section-title">
          <h2>About</h2>
          <p>About Us</p>
        </div> -->

      <div class="row">
        <div class="col-lg-12 text-center">
          <p class="fs-24">Securely connect your people with applications  &#64; uncompromised experience. </p>

          <p class="fs-19">The min SAAS Cloud provides APIs and Services for Enterprises to rapidly integrate and create a secure eco-system for their people to interact with their Applications and Services.</p>
          <!-- <p>
            At min, we firmly believe that companies only use a small functionality of their licensed

            third party products in the area of Identity Management, Security, and Infrastructure

            services to meet the Security, Regulatory, and Compliance Requirements of their

            respective enterprises. 

          </p>
          <p>But depending on the size of their company and the vendor they choose. Company pays: </p>
          <ul>
            <li><span class="material-icons">
                check_circle_outline
              </span> High upfront integration cost.</li>
            <li><span class="material-icons">
                check_circle_outline
              </span> License costs, and</li>
            <li><span class="material-icons">
                check_circle_outline
              </span> Annual recurring operational costs.</li>
          </ul>
          <p>
            All in all, they pay more but use minimally.
          </p>
          <p>min addresses this issue by creating a platform of Services with minimal but required functionality with the underlying principle to rapidly integrate and launch at a fraction of costs.  </p> -->
          <!-- <a href="javascript:void(0)" class="learn-more-btn">Read More</a> -->
        </div>
      </div>

    </div>
  </section>
  <section id="trainers" class="trainers pt-1">
    <div class="container">

      <div class="section-title mt-5">
        <h2>min Products</h2>
        <p>min Products</p>
      </div>
   <div class="col-lg-12 order-1 order-lg-2">
          <div class="row">
                <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                  <div class="member pointer"  [routerLink]="['/aboutminmfa']">
                    <img src="../../assets/images/01.png" class="img-fluid p-6 w-100" alt="" >
                    <div class="member-content">
                      <h4>Multi Factor Authentication</h4>
                      <!-- <span>Web Development</span> -->
                      <!-- <p>
                          Magni qui quod omnis unde et eos fuga et exercitationem. Odio veritatis perspiciatis quaerat qui aut aut
                          aut
                        </p> -->
                      <div class="align-items-center lernmore">
                        <button class="btn btn-outline px-30" [routerLink]="['/aboutminmfa']">Learn more</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                  <div class="member">
                    <img src="../../assets/images/02.png" class="img-fluid p-6 w-100" alt="" >
                    <div class="member-content">
                      <h4>Single Sign-on</h4>
                      <!-- <span>Marketing</span> -->
                      <p>
                        Federation - SAML 2.0<br>
                        Open Id Connect <br>
                        Adaptive <br>
                        Contextual <br><br><br>
                      </p>
                      <div class="align-items-center lernmore">
                        <button class="btn btn-outline px-30">Learn more</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                  <div class="member">
                    <img src="../../assets/images/03.png" class="img-fluid p-6 w-100" alt="" >
                    <div class="member-content">
                      <h4>API Access Management</h4>
                      <!-- <span>Cloud</span> -->
                      <p>
                        oAuth 2.0 Support <br>
                        Access Verification
                      </p>
                      <div class="align-items-center lernmore">
                        <button class="btn btn-outline px-30">Learn more</button>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
      </section>
  <!-- End About Section -->

  <!-- ======= Counts Section ======= -->
  <!-- <section id="counts" class="counts section-bg">
    <div class="container">

      <div class="row counters">

        <div class="col-lg-3 col-6 text-center">
          <span data-toggle="counter-up">1232</span>
          <p>Clients</p>
        </div>

        <div class="col-lg-3 col-6 text-center">
          <span data-toggle="counter-up">64</span>
          <p>Technologies</p>
        </div>

        <div class="col-lg-3 col-6 text-center">
          <span data-toggle="counter-up">42</span>
          <p>Events</p>
        </div>

        <div class="col-lg-3 col-6 text-center">
          <span data-toggle="counter-up">15</span>
          <p>Trainers</p>
        </div>

      </div>

    </div>
  </section> -->
  <!-- End Counts Section -->

  <!-- ======= Why Us Section ======= -->
  <!-- <section id="why-us" class="why-us">
    <div class="container">

      <div class="row">
        <div class="col-lg-4 d-flex align-items-stretch">
          <div class="content">
            <h3>Why Choose Min Identity?</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Duis aute irure dolor in reprehenderit
              Asperiores dolores sed et. Tenetur quia eos. Autem tempore quibusdam vel necessitatibus optio ad corporis.
            </p>
            <div class="text-center">
              <a href="about.html" class="more-btn">Learn More <i class="bx bx-chevron-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-8 d-flex align-items-stretch">
          <div class="icon-boxes d-flex flex-column justify-content-center">
            <div class="row">
              <div class="col-xl-4 d-flex align-items-stretch">
                <div class="icon-box mt-4 mt-xl-0">
                  <span class="material-icons">
                    monetization_on
                  </span>
                  <h4>Low Cost</h4>
                  <p>Consequuntur sunt aut quasi enim aliquam quae harum pariatur laboris nisi ut aliquip</p>
                </div>
              </div>
              <div class="col-xl-4 d-flex align-items-stretch">
                <div class="icon-box mt-4 mt-xl-0">
                  <span class="material-icons">
                    phonelink_lock
                  </span>
                  <h4>High Sequrity</h4>
                  <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt</p>
                </div>
              </div>
              <div class="col-xl-4 d-flex align-items-stretch">
                <div class="icon-box mt-4 mt-xl-0">
                  <span class="material-icons">
                    live_help
                  </span>
                  <h4>24/7 Support</h4>
                  <p>Aut suscipit aut cum nemo deleniti aut omnis. Doloribus ut maiores omnis facere</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>  -->
  
  <!-- End Why Us Section -->

  <!-- ======= Features Section ======= -->
  <!-- <section id="features" class="features">
    <div class="container">
      <div class="section-title" style="padding-top: 10px;">
        <h2>We Provides</h2>
        <p>We Provides</p>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-4">
          <div class="icon-box">
            <span class="material-icons" style="color: #e80368">
              vpn_lock
            </span>
            <h3><a href="course-details.html">Min MFA</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4 mt-md-0">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="course-details.html">BlockChain Consent</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4 mt-md-0">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="course-details.html">SAML Compliant SSO Server</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4 mt-lg-0">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="course-details.html">Multi Factor Authentication </a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="course-details.html">MinIdentity API’s </a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="course-details.html">Mobile SSO</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="course-details.html">Mobile SSO</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <i class="ri-price-tag-2-line" style="color: #4233ff;"></i>
            <h3><a href="">SAAS on AWS</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="">SAML</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="">Google Authenticator</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="">Mobile SSO</a></h3>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 mt-4">
          <div class="icon-box">
            <span class="material-icons">
              done
            </span>
            <h3><a href="">SAAS on AWS</a></h3>
          </div>
        </div>
      </div>

    </div>
  </section> -->
 
  <!-- End Features Section -->

  <!-- ======= Popular Courses Section ======= -->
  <!-- <section id="popular-courses" class="courses">
    <div class="container">

      <div class="section-title">
        <h2>We Provides</h2>
        <p>We Provides</p>
      </div>

      <div class="row">

        <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div class="course-item">
            <div class="icon-weprovide mt-4 mt-xl-0">
              <i class="bx bx-receipt"></i>
            </div>
            <div class="course-content">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h4>Min Identity</h4>
                <p class="price">$169</p>
              </div>

              <h3><a href="course-details.html">Website Design</a></h3>
              <p>Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem
                tempore. Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores
                dolorem tempore.</p>
              <div class="trainer d-flex justify-content-between align-items-center">
                <div class="trainer-profile d-flex align-items-center">
                  <button class="btn btn-outline">Add to cart</button>
                </div>
                <div class="trainer-rank d-flex align-items-center">
                  <i class="bx bx-user"></i>&nbsp;50
                  &nbsp;&nbsp;
                  <i class="bx bx-heart"></i>&nbsp;65
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div class="course-item">
            <div class="icon-weprovide mt-4 mt-xl-0">
              <i class="bx bx-receipt"></i>
            </div>
            <div class="course-content">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h4>Min SSO</h4>
                <p class="price">$169</p>
              </div>

              <h3><a href="course-details.html">Website Design</a></h3>
              <p>Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem
                tempore.Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem
                tempore.</p>
              <div class="trainer d-flex justify-content-between align-items-center">
                <div class="trainer-profile d-flex align-items-center">
                  <button class="btn btn-outline">Add to cart</button>
                </div>
                <div class="trainer-rank d-flex align-items-center">
                  <i class="bx bx-user"></i>&nbsp;50
                  &nbsp;&nbsp;
                  <i class="bx bx-heart"></i>&nbsp;65
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div class="course-item">
            <div class="icon-weprovide mt-4 mt-xl-0">
              <i class="bx bx-receipt"></i>
            </div>
            <div class="course-content">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h4>Min MFA</h4>
                <p class="price">$169</p>
              </div>

              <h3><a href="course-details.html">Website Design</a></h3>
              <p>Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem
                tempore.Et architecto provident deleniti facere repellat nobis iste. Id facere quia quae dolores dolorem
                tempore.</p>
              <div class="trainer d-flex justify-content-between align-items-center">
                <div class="trainer-profile d-flex align-items-center">
                  <button class="btn btn-outline">Add to cart</button>
                </div>
                <div class="trainer-rank d-flex align-items-center">
                  <i class="bx bx-user"></i>&nbsp;50
                  &nbsp;&nbsp;
                  <i class="bx bx-heart"></i>&nbsp;65
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </section> -->
  
  <!-- End Popular Courses Section -->

  <!-- ======= Trainers Section ======= -->
  <!-- End Trainers Section -->

</main><!-- End #main -->

<!-- ======= Footer ======= -->
<footer id="footer">

  <div class="footer-top">
    <div class="container">
      <div class="row">

        <div class="col-lg-4 col-md-6 footer-contact">
          <h3>min</h3>
          <p>
            9765 Baltic Lane <br>
            Frsico,TX 75035<br>
            United States <br><br>
            <strong>Phone:</strong> 913-706-5565<br>
            <strong>Email:</strong> info&#64;minaws.com<br>
          </p>
        </div>

        <div class="col-lg-4 col-md-6 footer-links">
          <h4>Useful Links</h4>
          <ul>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)" title="Home">Home</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)"  title="About Us">About us</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)" title="Services">Services</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)" title="Terms of Setvices">Terms of service</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)" title="Privacy Policy">Privacy policy</a></li>
          </ul>
        </div>

        <div class="col-lg-4 col-md-6 footer-links">
          <h4>Our Services</h4>
          <ul>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)" title="min MFA">min MFA</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)" title="min SSO">min SSO</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="javascript:void(0)" title="min Identity">min Identitity</a></li>
          </ul>
        </div>

        <!-- <div class="col-lg-4 col-md-6 footer-newsletter">
          <form action="" method="post">
            <input type="email" name="email"><input type="submit" value="Subscribe">
          </form>
        </div> -->

      </div>
    </div>
  </div>

  <div class="container d-md-flex py-4">

    <div class="mr-md-auto text-center text-md-left">
      <div class="copyright">
        &copy; Copyright <strong><span>min</span></strong>. All Rights Reserved
      </div>
      <div class="credits">
        <!-- All the links in the footer should remain intact. -->
        <!-- You can delete the links only if you purchased the pro version. -->
        <!-- Licensing information: https://bootstrapmade.com/license/ -->
        <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/Min Identity-free-education-bootstrap-theme/ -->
        Designed by <a href="javascript:void(0)">min</a>
      </div>
    </div>
    <div class="social-links text-center text-md-right pt-3 pt-md-0">
      <a href="javascript:void(0)" title="Twitter" class="twitter"><i class="bx bxl-twitter"></i></a>
      <a href="javascript:void(0)" title="Face Book" class="facebook"><i class="bx bxl-facebook"></i></a>
      <a href="javascript:void(0)" title="Instagram" class="instagram"><i class="bx bxl-instagram"></i></a>
      <a href="javascript:void(0)" title="Google-plus" class="google-plus"><i class="bx bxl-skype"></i></a>
      <a href="javascript:void(0)" title="linked In" class="linkedin"><i class="bx bxl-linkedin"></i></a>
    </div>
  </div>
</footer>
